import styled from 'styled-components'

export const AlertsViewContainer = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  height: 100%;
  @media (max-width: 1200px) {
    flex-direction: column;
    margin-top: 130px;
    margin-bottom: 20px;
    gap:15px;
  }
  
`
const type = {
  Urgent: '#de5141',
  Warning: '#ffec3d',
  Critical: 'ff5100',
  none: '#000000',
}

export const AlertMessageDiv = styled.div<{
  type: 'Warning' | 'Critical' | 'Urgent' | 'none'
}>`
  padding: 4px;
  border-radius: 5px;
  font-weight: 500;
  background-color: ${(props) => type[props.type]};
  color: white;
  padding: 8px;
  border-radius: 5px;
  display: inline-block;
  line-height: 20px;
  text-align: justify;
  box-shadow:
    rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
`
